import { createReducer, on } from "@ngrx/store";
import { CentreState, initialCentreState } from "./centre.state";
import {
  AddCentre,
  AddCentreError,
  AddCentreSuccess,
  CheckIsValidCentreName,
  CheckIsValidCentreNameError,
  CheckIsValidCentreNameSuccess,
  ClearCentreState,
  ClearCrudCentreState,
  DeleteCentre,
  DeleteCentreError,
  DeleteCentreSuccess,
  GetAllCentre,
  GetAllCentreError,
  GetAllCentreSuccess,
  GetAllCentresByOrgIds,
  GetAllCentresByOrgIdsError,
  GetAllCentresByOrgIdsSuccess,
  GetAllCentresByOrgIdsTutorFlow,
  GetAllCentresByOrgIdsTutorFlowError,
  GetAllCentresByOrgIdsTutorFlowSuccess,
  GetCentreTable,
  GetCentreTableError,
  GetCentreTableLength,
  GetCentreTableLengthError,
  GetCentreTableLengthSuccess,
  GetCentreTableSuccess,
  GetCentresByOrgId,
  GetCentresByOrgIdError,
  GetCentresByOrgIdSuccess,
  GetCentresByUserIdAndOrgId,
  GetCentresByUserIdAndOrgIdError,
  GetCentresByUserIdAndOrgIdSuccess,
  ResetAllCentresByOrgIds,
  ResetCentreTable,
  ResetCentreTableError,
  ResetCentreTableSuccess,
  ResetCentreTableUnload,
  ResetCentresByOrgIdList,
  ResetDeleteCentre,
  SetCentreData,
  UpdateCentre,
  UpdateCentreError,
  UpdateCentreSuccess,
  UpdateCentreTable,
  UpdateCentreTableError,
  UpdateCentreTableSuccess,
  ValidateDeleteCentre,
  ValidateDeleteCentreError,
  ValidateDeleteCentreSuccess,
} from "./centre.actions";

export const CentreReducers = createReducer(
  initialCentreState,
  on(CheckIsValidCentreName, (state): CentreState => {
    return {
      ...state,
      loading: true,
      error: null,
      validCentre: null,
      proceedStep: false,
    };
  }),
  on(CheckIsValidCentreNameSuccess, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      validCentre: action.result,
      proceedStep: action.result === true,
    };
  }),
  on(CheckIsValidCentreNameError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      validCentre: false,
      error: action.error,
      proceedStep: false,
    };
  }),
  on(SetCentreData, (state, action): CentreState => {
    return {
      ...state,
      crudData: action.centre,
      crudDataLoader: false,
    };
  }),
  on(AddCentre, (state): CentreState => {
    return {
      ...state,
      crudCentreLoader: true,
      crudResult: null,
      crudError: null,
    };
  }),
  on(AddCentreSuccess, (state, action): CentreState => {
    return {
      ...state,
      crudCentreLoader: false,
      crudResult: action.result,
    };
  }),
  on(AddCentreError, (state, action): CentreState => {
    return {
      ...state,
      crudCentreLoader: false,
      crudError: action.error,
    };
  }),
  on(UpdateCentre, (state): CentreState => {
    return {
      ...state,
      crudCentreLoader: true,
      crudResult: null,
      crudError: null,
    };
  }),
  on(UpdateCentreSuccess, (state, action): CentreState => {
    return {
      ...state,
      crudCentreLoader: false,
      crudResult: action.centre,
    };
  }),
  on(UpdateCentreError, (state, action): CentreState => {
    return {
      ...state,
      crudCentreLoader: false,
      crudError: action.error,
    };
  }),
  on(ClearCentreState, (): CentreState => {
    return initialCentreState;
  }),
  on(ClearCrudCentreState, (state): CentreState => {
    return {
      ...state,
      crudCentreLoader: false,
      crudError: null,
      crudResult: null,
    };
  }),
  on(UpdateCentreTable, (state): CentreState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(UpdateCentreTableSuccess, (state): CentreState => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(UpdateCentreTableError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(GetCentreTable, (state): CentreState => {
    return {
      ...state,
      loading: true,
            isGetTableOverallLength: false,
    };
  }),
  on(GetCentreTableSuccess, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      centreRecords: action.result,
            isGetTableOverallLength: action.isGetLength,
    };
  }),
  on(GetCentreTableError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      error: action.error,
            isGetTableOverallLength: false,
    };
  }),
  on(GetCentreTableLength, (state): CentreState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(GetCentreTableLengthSuccess, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      centreRecordsLength: action.result,
    };
  }),
  on(GetCentreTableLengthError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(GetCentresByUserIdAndOrgId, (state): CentreState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(GetCentresByUserIdAndOrgIdSuccess, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      list: action.result.slice().sort((a,b) => a.name.localeCompare(b.name)),
    };
  }),
  on(GetCentresByUserIdAndOrgIdError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(GetCentresByOrgId, (state): CentreState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(GetCentresByOrgIdSuccess, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      list: action.result.slice().sort((a,b) => a.name.localeCompare(b.name)),
    };
  }),
  on(GetCentresByOrgIdError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(ResetCentresByOrgIdList, (state): CentreState => {
    return {
      ...state,
      list: []
    };
  }),
  on(ResetCentreTable, (state): CentreState => {
    return {
      ...state,
      loading: true,
            isInitialLoadFlowReset: false,
    };
  }),
  on(ResetCentreTableSuccess, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
            isInitialLoadFlowReset: action.isInitialLoad
            ,
    };
  }),
  on(ResetCentreTableError, (state, action): CentreState => {
    return {
      ...state,
      loading: false,
      error: action.error,
            isInitialLoadFlowReset: false,
    };
  }),
  on(ResetCentreTableUnload, (state): CentreState => {
    return {
      ...state,
      centreRecords: [],
    };
  }),
  on(GetAllCentre, (state): CentreState => {
    return {
      ...state,
    }
  }),
  on(GetAllCentreSuccess, (state, action): CentreState => {
    return {
      ...state,
      centreList: action.result
    }
  }),
  on(GetAllCentreError, (state, action): CentreState => {
    return {
      ...state,
      error: action.error
    }
  }),
  on(GetAllCentreError, (state, action): CentreState => {
    return {
      ...state,
      error: action.error
    }
  }),
  on(DeleteCentre, (state): CentreState => {
    return {
      ...state,
      deleteCentreLoader: true,
      loading: true,
      isDeleteCentre: false,
      deleteCentreError: null
    }
  }),
  on(DeleteCentreSuccess, (state, action): CentreState => {
    return {
      ...state,
      deleteCentreLoader: false,
      loading: false,
      isDeleteCentre: action.isDeletedSuccessFully
    }
  }),
  on(DeleteCentreError, (state, action): CentreState => {
    return {
      ...state,
      deleteCentreLoader: false,
      loading: false,
      isDeleteCentre: false,
      deleteCentreError: action.error
    }
  }),
  on(ValidateDeleteCentre, (state): CentreState => {
    return {
      ...state,
      isValidDeleteCentre: false,
      validateDeleteCentreError: null
    }
  }),
  on(ValidateDeleteCentreSuccess, (state, action): CentreState => {
    return {
      ...state,
      isValidDeleteCentre: action.isValid
    }
  }),
  on(ValidateDeleteCentreError, (state, action): CentreState => {
    return {
      ...state,
      isValidDeleteCentre: false,
      validateDeleteCentreError: action.error
    }
  }),
  on(ResetDeleteCentre, (state): CentreState => {
    return {
      ...state,
      deleteCentreLoader: false,
      isDeleteCentre: false,
      isValidDeleteCentre: false,
      deleteCentreError: null,
      validateDeleteCentreError: null
    }
  }),
  on(GetAllCentresByOrgIds, (state): CentreState => {
    return {
      ...state,
      orgCentreList: null,
      orgCentreListLoader: true,
      orgCentreListError: null,
    }
  }),
  on(GetAllCentresByOrgIdsSuccess, (state, action): CentreState => {
    return {
      ...state,
      orgCentreList: action.result,
      orgCentreListLoader: false
    }
  }),
  on(GetAllCentresByOrgIdsError, (state, action): CentreState => {
    return {
      ...state,
      orgCentreListLoader: false,
      orgCentreListError: action.error,
    }
  }),
    on(GetAllCentresByOrgIdsTutorFlow, (state): CentreState => {
    return {
      ...state,
      orgCentreList: null,
      orgCentreListLoader: true,
      orgCentreListError: null,
    }
  }),
  on(GetAllCentresByOrgIdsTutorFlowSuccess, (state, action): CentreState => {
    return {
      ...state,
      orgCentreList: action.result,
      orgCentreListLoader: false
    }
  }),
  on(GetAllCentresByOrgIdsTutorFlowError, (state, action): CentreState => {
    return {
      ...state,
      orgCentreListLoader: false,
      orgCentreListError: action.error,
    }
  }),
  on(ResetAllCentresByOrgIds, (state): CentreState => {
    return {
      ...state,
      orgCentreList: []
    }
  }),
);
